import axios from "axios"

const SEND_MAIL_API = process.env.SEND_MAIL_API
const ADMINS_MAILS = process.env.ADMINS_MAILS

export const sendMail = async (mailDetails, sourceForm) => {
  mailDetails.submit && delete mailDetails.submit
  try {
    const adminsMails = convertEmailStringToArray(ADMINS_MAILS)

    const internal_msg = {
      to: adminsMails,
      internal: true,
      template: "internal",
      dynamic_template_data: { ...mailDetails, sourceForm },
    }

    const msg = {
      to: [mailDetails?.email],
      template: "feedback",
      dynamic_template_data: {},
    }

    await axios.post(SEND_MAIL_API, internal_msg, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    await axios.post(SEND_MAIL_API, msg, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    return { success: true, error: null, message: "Message sent" }
  } catch (error) {
    return { success: false, error, message: "Error while sending the message" }
  }
}
export const sendWelcomeMail = async (userMail = "") => {
  try {
    let msg
    if (userMail) {
      msg = {
        to: [userMail],
        subject: "MAXapps: Welcome to maxapps-maximo!",
        template: "newsLetter",
        dynamic_template_data: {},
      }

      await axios.post(SEND_MAIL_API, msg, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    } else {
      return {
        success: false,
        error: "receptions list empty",
        message: "Error while sending the welcome email",
      }
    }
    return { success: true, error: null, message: "welcome email sent" }
  } catch (error) {
    return {
      success: false,
      error,
      message: "Error while sending the welcome email",
    }
  }
}
export const sendNewsLetterMail = async (userMails = []) => {
  try {
    let msg
    msg = {
      to: [],
      bcc: userMails,
      subject: "MAXapps: Welcome to maxapps-maximo!",
      template: "newsLetter",
      dynamic_template_data: {},
    }

    await axios.post(SEND_MAIL_API, msg, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    return { success: true, error: null, message: "email sent" }
  } catch (error) {
    return { success: false, error, message: "Error while sending the email" }
  }
}

const convertEmailStringToArray = (emails = "") => {
  const adminsMails = emails.split(":").filter(mail => {
    if (validateEmail(mail)) {
      return mail
    }
  })

  return adminsMails
}
const validateEmail = email => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  )
}
